<div class="m-3">
  <div class="row">
    <div class="col-8 d-flex align-items-center px-0">
      <div class="player-img-container rounded-circle overflow-hidden me-2">
        <img src="{{ fantasyHistoryItem.PlayerImage | contentImage: '6' }}" class="h-100 w-100" />
      </div>
      <div class="d-flex align-items-center">
        <div>
          <div class="font-size-14 fw-bold">
            {{ fantasyHistoryItem.PlayerName }}
          </div>
          <div class="d-inline-flex">
            <div class="svg svg-black vs-svg" [inlineSVG]="'assets/images/icons/vs.svg'"></div>
            <div class="font-size-12 ms-2 mt-1">
              @if (fantasyHistoryItem.ClubPlayingStatus == 1) {
                {{ fantasyHistoryItem.AwayTeamName }}
              } @else {
                {{ fantasyHistoryItem.HomeTeamName }}
              }
              - {{ gameDate | date: 'MMM dd' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-4 d-flex align-items-center justify-content-end px-0">
      <div class="text-end font-size-14 fw-bold" *ngIf="!isPending; else pointsPending">
        <span *ngIf="fantasyHistoryItem.PlayerGamePoints > 0">+</span>
        {{ fantasyHistoryItem.PlayerGamePoints / 100 | FortressCurrencyPipe: 'PTS' }}
      </div>
      <ng-template #pointsPending>
        <span class="font-size-14 text-info fw-bold">{{ 'pick.player.history.points.pending' | translate }}</span>
      </ng-template>
    </div>
  </div>
</div>
